import { Box, Heading } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { HEADING_VARIANTS } from "@/theme/components/heading";

const BlogCard = ({ title, image, slug }) => {
  return (
    <Box
      shadow={"md"}
      bg="white"
      padding={"0.25rem 0.5rem 0.75rem 0.5rem"}
      borderRadius={"10px"}
      border={"1px solid #eee"}
      transition={"0.3s"}
      minH={"380px"}
      display={"flex"}
      flexDir={"column"}
      maxWidth={"360px"}
      _hover={{
        shadow: "lg",
      }}
      gap={"2rem"}
    >
      <Box width={"100%"}>
        <Image src={image} alt={title} objectFit="cover" />
      </Box>
      <Heading variant={HEADING_VARIANTS.SUBTITLE3} px={2}>
        {title}
      </Heading>
      <Link
        href={slug}
        style={{
          color: "#021B66",
          textDecoration: "underline",
          textUnderlineOffset: "0.5rem",
          textDecorationThickness: "0.1rem",
          fontWeight: "600",
        }}
      >
        Read Story
      </Link>
    </Box>
  );
};

export default BlogCard;
